<div class="input-group no-border mr-1 ml-1">
<!--     <select class="custom-select custom-select">
        <option [value]="-1" *ngIf="includeall">
            {{includeall_text}}
        </option>
        <option *ngFor="let item of mylist" [value]="item.id">
            {{item.name}}
        </option>
      </select> -->

    <mat-form-field appearance="outline">
        <mat-label *ngIf="myplaceholder">{{myplaceholder}}</mat-label>
        <mat-select #filterby [placeholder]="myplaceholder" [(ngModel)]="selecteditem" (selectionChange)="changeitem($event)">
            <mat-option [value]="-1" *ngIf="includeall">
                {{includeall_text}}
            </mat-option>
            <mat-option *ngFor="let item of mylist" [value]="item.id">
                {{item.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
